import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { I18nProvider } from './i18n';
import './styles.css';

/** Pages drawn on a painted plate are laid out on the concepts' 1536px canvas and zoomed to the window. */
const fitStage = () => document.documentElement.style.setProperty('--k', String(Math.min(window.innerWidth, 1920) / 1536));
fitStage();
window.addEventListener('resize', fitStage);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
);
